import { InstallDesktopOutlined } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type SafariNavigator = Navigator & { standalone?: boolean };

function isSafari() {
  return /Safari/i.test(navigator.userAgent)
    && !/Chrome|CriOS|Chromium|Edg|OPR|Android/i.test(navigator.userAgent);
}

function isIos() {
  return /iPad|iPhone|iPod/i.test(navigator.userAgent)
    || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

function isInstalled() {
  return window.matchMedia("(display-mode: standalone)").matches
    || Boolean((navigator as SafariNavigator).standalone);
}

export function SafariInstallButton() {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  if (!isSafari() || isInstalled()) return null;
  const french = i18n.resolvedLanguage?.startsWith("fr") ?? true;
  const installLabel = `${t("transverse.app.pwa.install")} ObvioWMS`;
  const instructions = isIos()
    ? (french
      ? "Touchez Partager, puis Ajouter à l’écran d’accueil. Activez Ouvrir comme app web, puis touchez Ajouter."
      : "Tap Share, then Add to Home Screen. Enable Open as Web App, then tap Add.")
    : (french
      ? "Dans Safari, cliquez sur Partager puis sur Ajouter au Dock. Vous pouvez aussi utiliser Fichier > Ajouter au Dock. Cette fonction nécessite macOS Sonoma 14 ou une version ultérieure."
      : "In Safari, click Share, then Add to Dock. You can also use File > Add to Dock. This feature requires macOS Sonoma 14 or later.");

  return <>
    <IconButton color="inherit"
      aria-label={installLabel}
      title={installLabel}
      onClick={() => setOpen(true)}>
      <InstallDesktopOutlined />
    </IconButton>
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>{installLabel}</DialogTitle>
      <DialogContent>
        <Typography>{instructions}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)}>{french ? "Fermer" : "Close"}</Button>
      </DialogActions>
    </Dialog>
  </>;
}
